const SUPABASE_URL = process.env.REACT_APP_SUPA_URL;
const SUPABASE_SUBMIT_URL = `${SUPABASE_URL}/functions/v1/register-fart-submission`;
const SUPABASE_FETCH_SUBMISSIONS_URL = `${SUPABASE_URL}/functions/v1/get-fart-submissions`;
const ANON_KEY = process.env.REACT_APP_SUPA_ANON_KEY;

/**
 * Generic function to call Supabase Edge Functions
 * @param {string} functionName - The name of the Supabase function
 * @param {Object} body - The request body
 * @param {Object} [options] - Optional headers
 * @returns {Promise} The response data
 */
export async function callSupabaseFunction(functionName, body, options ) {
  const url = `${SUPABASE_URL}/functions/v1/${functionName}`;
  const headers = {
    "Content-Type": "application/json",
    ...(ANON_KEY && { Authorization: `Bearer ${ANON_KEY}` }),
    ...options?.headers,
  };

  const response = await fetch(url, {
    method: "POST",
    headers,
    body: JSON.stringify(body),
  });

  const data = await response.json();

  if (!response.ok || data?.success === false) {
    throw new Error(data?.error || `Failed to call ${functionName}`);
  }

  return data;
}

/**
 * Submit a fart submission to Supabase
 * @param {string} txId - Transaction ID
 * @param {string} senderPublicKey - Sender's public key
 * @param {Object} fartData - Fart data to submit
 * @returns {Promise} The response data
 */
export async function callSupabaseFartSubmission(txId, senderPublicKey, fartData) {
  try {
    const payload = {
      txId,
      senderWallet: senderPublicKey,
      fartData,
    };

    const headers = {
      "Content-Type": "application/json",
      ...(ANON_KEY && { Authorization: `Bearer ${ANON_KEY}` }),
    };

    const response = await fetch(SUPABASE_SUBMIT_URL, {
      method: "POST",
      headers,
      body: JSON.stringify(payload),
    });

    const result = await response.json();
    if (!response.ok) {
      throw new Error(result?.error || "Failed to submit fart");
    }

    return result;
  } catch (error) {
    console.error("❌ Error calling Supabase register-fart-submission:", error);
    return { success: false, error: error.message };
  }
}

/**
 * Get FLART purchase cost
 * @param {string} type - Purchase type
 * @returns {Promise} Cost information
 */
export async function getFlartPurchaseCost(type) {
  return callSupabaseFunction("get-purchase-price", { type });
}

/**
 * Fetch fart submissions with optional filters
 * @param {Object} params - Filter parameters
 * @returns {Promise} Array of submissions
 */
export async function fetchFartSubmissions(params) {
  const result = await callSupabaseFunction("get-fart-submissions", params);
  if (!result?.data) {
    return [];
  }
  return result.data;
}


/**
 * Submit a vote
 * @param {Object} params - Vote parameters
 * @returns {Promise} The vote result
 */
export async function submitVote({ vote, txId, senderWallet, championshipUuid }) {
  const result = await callSupabaseFunction("vote-submission", {
    txId,
    senderWallet,
    voteData: vote,
    championshipUuid,
  });
  if (!result?.vote) {
    return { success: false, error: result?.error };
  }
  return result.vote;
}

/**
 * Fetch votes with optional filters
 * @param {Object} params - Filter parameters
 * @returns {Promise} Array of votes
 */
export async function fetchVotes(params) {
  const result = await  callSupabaseFunction("get-votes", params);
    if (!result?.data) {
      return [];
    }
    return result.data;
}

/**
 * Get current championship data
 * @returns {Promise} Championship data
 */
export async function getCurrentChampionship() {
    const result = await callSupabaseFunction("get-current-championship");
    if (!result?.championship) {
      return [];
    }
    return result.championship;
}
